import { ze } from "utils/zhEn";
const testJsonData = {
    "analysis": {
        "step1InitialHypotheses": [
            {
                "id": 1,
                "type": "内存访问越界",
                "evidence": "崩溃发生在OnTestCrash函数中，尝试访问一个非法指针",
                "evidenceData": "崩溃堆栈显示在Unlua426Character.cpp:188行访问了非法指针",
                "reasoning": "代码中直接将计数器值转换为指针并解引用，当counter超过5时会访问非法内存",
                "platformRelevance": "所有平台都会崩溃，但Android平台更容易暴露内存问题"
            },
            {
                "id": 2,
                "type": "Lua/C++交互错误",
                "evidence": "崩溃发生在Lua调用C++函数的过程中",
                "evidenceData": "堆栈显示从Lua的FunctionC调用到C++的OnTestCrash",
                "reasoning": "Lua和C++之间的类型转换或生命周期管理可能存在问题",
                "platformRelevance": "跨语言交互问题在所有平台都存在"
            },
            {
                "id": 3,
                "type": "线程安全问题",
                "evidence": "counter是静态变量，可能被多线程访问",
                "evidenceData": "崩溃发生在游戏线程(gamethread)",
                "reasoning": "静态变量counter没有同步保护，在多线程环境下可能产生竞争条件",
                "platformRelevance": "多线程问题在所有平台都存在"
            }
        ],
        "step2HypothesisEvaluation": {
            "evaluations": [
                {
                    "hypothesisId": 1,
                    "score": 9,
                    "reason": "直接证据表明是非法内存访问导致SIGSEGV",
                    "platformRelevance": "所有平台"
                },
                {
                    "hypothesisId": 2,
                    "score": 5,
                    "reason": "虽然涉及Lua/C++交互，但不是根本原因",
                    "platformRelevance": "所有平台"
                },
                {
                    "hypothesisId": 3,
                    "score": 4,
                    "reason": "虽然counter是静态变量，但当前崩溃场景不一定是多线程导致",
                    "platformRelevance": "所有平台"
                }
            ],
            "top3Hypotheses": [1, 2, 3]
        },
        "step3DeepExploration": {
            "hypothesisExplored": 1,
            "reasoningPath": [
                "崩溃直接发生在OnTestCrash函数中",
                "代码将counter值直接转换为指针并解引用",
                "当counter>5时访问非法内存地址"
            ],
            "rootCauseAnalysis": "根本原因是OnTestCrash函数中将递增的counter值直接转换为指针并解引用，这是一种故意的崩溃测试代码",
            "keyEvidence": [
                "崩溃堆栈指向OnTestCrash函数",
                "代码中明显的非法指针访问"
            ],
            "evidenceData": [
                "Unlua426Character.cpp:188行: return *ptr;",
                "counter变量被直接转换为指针"
            ],
            "codeChangeAnalysis": {
                "criticalChange": {
                    "author": "vincentwgao",
                    "date": "2025-08-07T03:48:07+0000",
                    "commitMessage": "feat：commit crashsight quest source code",
                    "changedCode": "static int OnTestCrash(lua_State* L) {\n    if (counter++ > 5) {\n        UE_LOG(LogTemp, Log, TEXT(\"lustest: begin to crash...\"));\n        int* ptr = reinterpret_cast<int*>(counter);\n        return *ptr;\n    }\n    return 0;\n}",
                    "impactAnalysis": "该变更故意添加了会导致崩溃的测试代码，当counter超过5时会访问非法内存地址"
                },
                "relatedChanges": []
            },
            "verificationSteps": [
                "检查counter变量的定义和使用",
                "验证OnTestCrash函数的调用路径"
            ],
            "platformRelevance": "所有平台都会因此崩溃"
        },
        "step4Conclusion": {
            "rootCause": "OnTestCrash函数中故意实现的崩溃测试代码导致非法内存访问",
            "responsibleChange": {
                "author": "vincentwgao",
                "date": "2025-08-07T03:48:07+0000",
                "commitMessage": "feat：commit crashsight quest source code",
                "changedCode": "static int OnTestCrash(lua_State* L) {\n    if (counter++ > 5) {\n        UE_LOG(LogTemp, Log, TEXT(\"lustest: begin to crash...\"));\n        int* ptr = reinterpret_cast<int*>(counter);\n        return *ptr;\n    }\n    return 0;\n}",
                "explanation": "该变更添加了故意导致崩溃的测试代码，当counter超过5时会访问非法内存地址"
            },
            "underlyingReason": "测试代码中故意实现的崩溃机制被触发",
            "evidenceChain": [
                {
                    "type": "堆栈帧",
                    "description": "崩溃堆栈明确指向OnTestCrash函数"
                },
                {
                    "type": "源码",
                    "description": "源码中可见明显的非法指针访问代码"
                },
                {
                    "type": "提交历史",
                    "description": "最近提交中明确添加了这段测试代码"
                }
            ],
            "evidenceData": [
                {
                    "data": "Unlua426Character.cpp:188",
                    "description": "非法指针访问代码位置"
                },
                {
                    "data": "counter++ > 5条件判断",
                    "description": "崩溃触发条件"
                }
            ],
            "memoryUsageAnalysis": "无内存不足迹象，是明确的非法访问导致",
            "codeLocation": {
                "file": "Unlua426Character.cpp:188",
                "function": "OnTestCrash",
                "crashPoint": "return *ptr;"
            },
            "fixRecommendations": {
                "emergencyFix": {
                    "before": "int* ptr = reinterpret_cast<int*>(counter);\nreturn *ptr;",
                    "after": "// 移除或注释掉崩溃测试代码"
                },
                "rootCauseFix": "移除或禁用测试用的崩溃代码",
                "longTermProtection": "1. 添加代码审查流程防止提交测试用崩溃代码\n2. 对测试代码添加明显标记\n3. 实现自动化测试而非使用真实崩溃测试"
            },
            "logAnalysis": "日志显示'lustest: begin to crash...'，明确指示了测试崩溃被触发",
            "platformRelevance": "所有平台都会因此崩溃，与特定机型无关"
        }
    }
};
const testMarkdownData = `
### Step 1: 生成初始假设集

假设1: [C++对象生命周期管理]

- 证据:

  【堆栈】\`\`\`#00 pc 000000000010ffcc /data/app/.../libGCloudVoice.so\`\`\`

  【用户日志】\`\`\`07-29 <*> 25627 6944 I GCloudVoice: [GCloudVoice] |6944| ...\`\`\`

  【信号】\`\`\`SIGSEGV(SEGV_MAPERR)\`\`\`

- 推理: 虚函数调用时对象已被销毁，vtable指针失效导致访问非法地址 - 平台/机型相关性: Android 14系统可能修改了动态库加载机制

假设2: [多线程竞态条件]

- 证据:

【用户自定义kv】\`\`\`"C03_K#GarbageCollect":"normal"\`\`\`

  【系统日志】\`\`\`"W InputTransport: PerfMonitor: ... com.tencent.mf.uam/com.epicgames.ue4.GameActivity"\`\`\`

- 推理: 音频处理线程与UI线程存在资源竞争 - 平台/机型相关性: Adreno 650 GPU驱动线程调度策略可能影响

假设3: [内存分配器冲突]

- 证据:

  【用户自定义kv】\`\`\`"C03_K#AvailablePhysical":"1799.308594 MB"\`\`\`

  【系统日志】\`\`\`"E [CrashSightReport-Native]: last errno is <*>"\`\`\`

- 推理: 自定义分配器与系统malloc/free混用导致内存损坏 - 平台/机型相关性: Android 14新引入的Scudo分配器可能不兼容

假设4: [系统ABI不兼容]

- 证据:

  【系统版本分布】\`\`\`android 14,level 34占比: 100.00%\`\`\`

  【堆栈】\`\`\`#09 pc 00000000000fd528 ... libc.so (ns_parserr+588)\`\`\`






- 推理: Android 14动态链接库符号解析规则变更导致 - 平台/机型相关性: 仅影响Android 14设备


假设5: [异步回调失效]

- 证据:

  【用户日志】\`\`\`"I GCloudVoice: [GCloudVoice] ... sessionId <*>"\`\`\`

  【用户自定义kv】\`\`\`"C03_K#CurrentMap":"FrontEndMap"\`\`\`

- 推理: 场景切换时未及时注销语音回调 - 平台/机型相关性: 小米ROM后台进程管理策略可能提前回收资源


---

### Step 2: 评估假设置信度

假设1 评分: 8 - 理由: 堆栈集中在语音库内部，SEGV_MAPERR典型特征 - 平台相关性: Android 14符号解析变更
假设4 评分: 7 - 理由: 100%发生在Android 14设备 - 平台相关性: 明确系统版本关联
假设5 评分: 6 - 理由: 地图切换日志与语音会话ID共存 - 机型相关性: 小米后台管理严格
假设2 评分: 5 - 理由: 存在多线程日志但无直接竞态证据
假设3 评分: 4 - 理由: 可用内存充足，无OOM迹象

Top3 假设: [假设1 > 假设4 > 假设5]

---

### Step 3: 深度探索高置信假设

深度探索假设: C++对象生命周期管理
推演路径:
1. 崩溃发生在libGCloudVoice.so内部函数调用链
   → Why? 虚函数表访问异常
2. 最终调用栈到达libc的ns_parserr
   → Why? DNS解析相关回调未及时取消
3. 用户日志显示语音会话与地图切换共存
   → Why? 场景切换时语音模块未正确释放资源
4. Android 14动态库加载顺序变更
   → Why? 全局对象析构顺序变化导致use-after-free

底层why:
跨模块全局对象析构顺序问题。当游戏切出FrontEndMap时，UE引擎销毁语音模块对象，但libGCloudVoice的DNS解析线程仍在运行，尝试访问已销毁的C++对象虚表。

关键证据:
【用户自定义kv】\`\`\`"C03_K#CurrentMap":"FrontEndMap"\`\`\`
【系统日志】\`\`\`"W InputTransport: PerfMonitor: ... GameActivity"\`\`\`

待验证操作:
1. 检查GCloudVoice::Destroy()是否同步等待所有线程退出
2. 验证Android 14动态库卸载时是否立即终止线程

平台相关性:
Android 14(bionic版本更新)修改了动态库卸载策略，更积极回收资源，加剧析构顺序问题

---

### Step 4: 专家结论与修复建议

最可能根因:
**跨模块全局对象析构顺序问题**导致use-after-free。当游戏场景切换时，UE引擎销毁语音模块对象，但libGCloudVoice的异步DNS解析线程仍在访问已释放对象的虚表。

底层why归纳:
libGCloudVoice在\`ns_parserr\`回调中未正确同步对象生命周期，Android 14更激进的动态库卸载机制导致内存安全漏洞。

证据链:
1. 崩溃堆栈显示从语音库到libc的DNS解析路径
2. 用户日志显示崩溃时正在进行地图切换
3. 100%发生在Android 14设备，新版bionic库变更内存回收策略

关键代码定位:
文件: GCloudVoiceSessionManager.cpp
函数: ~VoiceSession()
崩溃点: 未同步停止网络线程直接释放对象

\`\`\`cpp
// 修复前
VoiceSession::~VoiceSession() {
    m_running = false; // 仅设置标志位
}

// 修复后
VoiceSession::~VoiceSession() {
    m_running = false;
    if (m_networkThread.joinable()) {
        m_networkThread.join(); // 等待线程退出
    }
}
\`\`\`

修复建议:
1. 紧急止血: 在析构函数增加线程同步
2. 根因修复: 实现引用计数智能指针管理共享资源
3. 长期加固: 增加跨模块生命周期监控日志

机型相关性分析:
Android 14设备因bionic库更新更易触发，Redmi K40S的UFS 3.1存储加速了资源回收过程

外挂相关性:
无root设备报告，排除外挂因素
`;
/**
 * 围栏代码块。开合反引号必须各自单独成行。
 * 同一行 ```text``` 会被 remark 解析成行内 code，再撞上全局 nowrap，长堆栈被裁掉。
 */
function markdownFence(body) {
    const text = String(body ?? '').replace(/\n+$/, '');
    return `\`\`\`\n${text}\n\`\`\`\n\n`;
}
/**
 * 代码在这些字符之后可以软换行。包含 Windows 路径的反斜杠。
 * 断点在符号后面，符号留在上一行末尾（如 `/Game/` 下一行再接目录名）。
 */
const CODE_BREAK_AFTER = new Set(['/', '\\', '_', '.']);
/**
 * 是否允许在 text[index] 之前断开。调用方在片段之间插入 <wbr>，不插入可见字符，复制仍是原文。
 *
 * 1. 小写后接大写：foo|Bar
 * 2. 连续大写接到下一个单词：FRHI|Command。前一个也是大写、当前大写、下一个小写，
 *    这样不会把 FRHI 拆成单字母。
 * 3. `/` `\` `_` `.` 之后，以及 `::` 之后。连续的同类符号（`//` `\\` `..` `__`）整组保留，
 *    断点在这一组后面。单个 `:`（如盘符 `C:`）不断开。
 *
 * 没有这些边界的长串（纯十六进制等）不从中间硬拆。
 */
function isCodeSoftBreakBefore(text, index) {
    const prev = text[index - 1];
    const curr = text[index];
    const next = text[index + 1];
    if (!prev || !curr) {
        return false;
    }
    if (/[a-z]/.test(prev) && /[A-Z]/.test(curr)) {
        return true;
    }
    if (/[A-Z]/.test(prev) && /[A-Z]/.test(curr) && !!next && /[a-z]/.test(next)) {
        return true;
    }
    if (CODE_BREAK_AFTER.has(prev)) {
        // 连续符号留在一起，断点放到这一组之后
        if (curr === prev) {
            return false;
        }
        return true;
    }
    // `::` 的第二个冒号之后
    return prev === ':' && text[index - 2] === ':';
}
/** 按驼峰和路径符号把代码切成片段。片段之间由渲染层插入 <wbr>。 */
function splitCodeForSoftWrap(text) {
    if (!text) {
        return [text];
    }
    const parts = [];
    let start = 0;
    for (let i = 1; i < text.length; i++) {
        if (isCodeSoftBreakBefore(text, i)) {
            parts.push(text.slice(start, i));
            start = i;
        }
    }
    parts.push(text.slice(start));
    return parts;
}
function isClosingFenceLine(line) {
    return /^ {0,3}`{3,}\s*$/.test(line);
}
function isFenceToggleLine(line) {
    return /^ {0,3}`{3,}[^`]*$/.test(line);
}
/** 引用按钮贴到文末。若文末是闭合围栏，先换行，避免标签粘在 ``` 上把围栏撑开。 */
function appendQuotedLogButton(content, index) {
    const trimmed = (content || '').trimEnd();
    const last = trimmed.split('\n').pop() || '';
    const sep = isClosingFenceLine(last) ? '\n' : '';
    return `${trimmed}${sep}<quoted-log-btn>${index}</quoted-log-btn>`;
}
/**
 * 按行贴引用按钮。围栏内部的命中留到闭合围栏的下一行，
 * 不把标签写进代码块。
 */
function enrichQuotedLogLines(lines, matchIndex) {
    let inFence = false;
    let pending = -1;
    const out = lines.map((line) => {
        if (!line) {
            return line;
        }
        if (isFenceToggleLine(line)) {
            if (inFence) {
                inFence = false;
                if (pending >= 0) {
                    const idx = pending;
                    pending = -1;
                    return `${line.trimEnd()}\n<quoted-log-btn>${idx}</quoted-log-btn>`;
                }
            }
            else {
                inFence = true;
            }
            return line;
        }
        const idx = matchIndex(line);
        if (idx >= 0) {
            if (inFence) {
                pending = idx;
                return line;
            }
            return `${line.trimEnd()}<quoted-log-btn>${idx}</quoted-log-btn>`;
        }
        return line;
    });
    if (pending >= 0) {
        out.push(`<quoted-log-btn>${pending}</quoted-log-btn>`);
    }
    return out;
}
/**
 * 将json格式的AI分析结论转换为markdown内容
 * */
function convertJsonTextToMarkdownText(jsonText) {
    if (!jsonText) {
        return '';
    }
    let jsonObject;
    try {
        jsonObject = JSON.parse(jsonText);
    }
    catch (e) {
        console.error('convertJsonTextToMarkdownText json parse error: ', e);
        return jsonText;
    }
    const { analysis } = jsonObject;
    if (!analysis) {
        return 'Invalid analysis data structure.';
    }
    let markdown = '';
    // Step 1: 生成初始假设集
    markdown += `### Step 1: ${ze('生成初始假设集', 'Generate Initial Hypothesis Set')}\n\n`;
    if (analysis.step1InitialHypotheses) {
        analysis.step1InitialHypotheses.forEach((hypothesis, index) => {
            markdown += `${ze('假设', 'Hypothesis ')}${hypothesis.id}: [${hypothesis.type}]\n\n`;
            markdown += `- ${ze('证据', 'Evidence')}\n\n`;
            markdown += `  ${hypothesis.evidence}\n\n`;
            if (hypothesis.evidenceData) {
                markdown += markdownFence(hypothesis.evidenceData);
            }
            markdown += `- ${ze('推理', 'Reasoning')}: ${hypothesis.reasoning}`;
            if (hypothesis.platformRelevance) {
                markdown += ` - ${ze('平台/机型相关性', 'Platform Relevance')}: ${hypothesis.platformRelevance}`;
            }
            markdown += '\n\n';
        });
    }
    // Step 2: 评估假设置信度
    if (analysis.step2HypothesisEvaluation) {
        markdown += '---\n\n';
        markdown += `### Step 2: ${ze('评估假设置信度', 'Hypothesis Evaluation')}\n\n`;
        const { evaluations, top3Hypotheses } = analysis.step2HypothesisEvaluation;
        // Sort evaluations by score in descending order
        const sortedEvaluations = [...evaluations].sort((a, b) => b.score - a.score);
        sortedEvaluations.forEach(evaluation => {
            markdown += `${ze('假设', 'Hypothesis')}${evaluation.hypothesisId}${ze('：评分：', ': Score: ')}${evaluation.score}\n\n- ${ze('理由', 'Reason')}: ${evaluation.reason}`;
            if (evaluation.platformRelevance) {
                markdown += ` - ${ze('平台相关性', 'Platform Relevance')}: ${evaluation.platformRelevance}`;
            }
            markdown += '\n';
        });
        if (top3Hypotheses && top3Hypotheses.length > 0) {
            markdown += `\nTop3 ${ze('假设', 'Hypotheses')}: [${ze('假设', 'Hypothesis')}${top3Hypotheses.join(` > ${ze('假设', 'Hypothesis')}`)}]\n\n`;
        }
    }
    // Step 3: 深度探索高置信假设
    if (analysis.step3DeepExploration) {
        markdown += '---\n\n';
        markdown += `### Step 3: ${ze('深度探索高置信假设', 'Deep Exploration of High-Confidence Hypothesis')}\n\n`;
        const exploration = analysis.step3DeepExploration;
        // Find the hypothesis being explored
        const exploredHypothesis = analysis.step1InitialHypotheses?.find(h => h.id === exploration.hypothesisExplored);
        if (exploredHypothesis) {
            markdown += `${ze('深度探索假设', 'Deep Exploration Hypothesis')}: ${exploredHypothesis.type}\n`;
        }
        if (exploration.reasoningPath && exploration.reasoningPath.length > 0) {
            markdown += `${ze('推演路径', 'Reasoning Path')}:\n`;
            exploration.reasoningPath.forEach((step, index) => {
                markdown += `${index + 1}. ${step}\n`;
                if (index < exploration.reasoningPath.length - 1) {
                    markdown += '   → Why? ';
                }
            });
            markdown += '\n';
        }
        if (exploration.rootCauseAnalysis) {
            markdown += `${ze('底层why', 'Root Why')}:\n${exploration.rootCauseAnalysis}\n\n`;
        }
        if (exploration.keyEvidence && exploration.keyEvidence.length > 0) {
            markdown += `${ze('关键证据', 'Key Evidence')}:\n`;
            exploration.keyEvidence.forEach(evidence => {
                markdown += `${evidence}\n`;
            });
            if (exploration.evidenceData && exploration.evidenceData.length > 0) {
                exploration.evidenceData.forEach(data => {
                    markdown += markdownFence(data);
                });
            }
            markdown += '\n';
        }
        if (exploration.verificationSteps && exploration.verificationSteps.length > 0) {
            markdown += `${ze('待验证操作', 'Verification Steps')}:\n`;
            exploration.verificationSteps.forEach((step, index) => {
                markdown += `${index + 1}. ${step}\n`;
            });
            markdown += '\n';
        }
        if (exploration.platformRelevance) {
            markdown += `${ze('平台相关性', 'Platform Relevance')}:\n${exploration.platformRelevance}\n\n`;
        }
    }
    // Step 4: 专家结论与修复建议
    if (analysis.step4Conclusion) {
        markdown += '---\n\n';
        markdown += `### Step 4: ${ze('专家结论与修复建议', 'Expert Conclusion and Fix Recommendations')}\n\n`;
        const conclusion = analysis.step4Conclusion;
        if (conclusion.rootCause) {
            markdown += `${ze('最可能根因', 'Most Likely Root Cause')}:\n**${conclusion.rootCause}**\n\n`;
        }
        if (conclusion.underlyingReason) {
            markdown += `${ze('底层why归纳', 'Underlying Why Summary')}:\n${conclusion.underlyingReason}\n\n`;
        }
        if (conclusion.evidenceChain && conclusion.evidenceChain.length > 0) {
            markdown += `${ze('证据链', 'Evidence Chain')}:\n`;
            conclusion.evidenceChain.forEach((evidence, index) => {
                markdown += `${index + 1}. ${evidence.description}\n`;
            });
            markdown += '\n';
        }
        if (conclusion.codeLocation) {
            markdown += `${ze('关键代码定位', 'Key Code Location')}:\n`;
            markdown += `${ze('文件', 'File')}: ${conclusion.codeLocation.file}\n`;
            markdown += `${ze('函数', 'Function')}: ${conclusion.codeLocation.function}\n`;
            markdown += `${ze('崩溃点', 'Crash Point')}: ${conclusion.codeLocation.crashPoint}\n\n`;
        }
        if (conclusion.responsibleChange) {
            markdown += '---\n';
            markdown += `${ze('代码变更信息', 'Code Change Information')}:\n`;
            const change = conclusion.responsibleChange;
            if (change.author) {
                markdown += `> **${ze('作者', 'Author')}**: ${change.author}  \n`;
            }
            if (change.date) {
                markdown += `> **${ze('日期', 'Date')}**: ${change.date}  \n`;
            }
            if (change.commitMessage) {
                markdown += `> **${ze('提交信息', 'Commit Message')}**: ${change.commitMessage}  \n`;
            }
            if (change.explanation) {
                markdown += `> **${ze('变更说明', 'Change Description')}**: ${change.explanation}  \n`;
            }
            if (change.impactAnalysis) {
                markdown += `> **${ze('影响分析', 'Impact Analysis')}**: ${change.impactAnalysis}  \n`;
            }
            if (change.changedCode) {
                markdown += `> **${ze('变更代码', 'Changed Code')}**:\n`;
                markdown += '> ```cpp\n';
                // Split the code by lines and add > prefix to each line
                const codeLines = change.changedCode.split('\n');
                codeLines.forEach(line => {
                    markdown += `> ${line}\n`;
                });
                markdown += '> ```\n';
            }
            markdown += '  \n';
        }
        if (conclusion.fixRecommendations) {
            const fix = conclusion.fixRecommendations;
            markdown += `${ze('修复建议', 'Fix Recommendations')}:\n`;
            if (fix.emergencyFix && fix.emergencyFix.after) {
                markdown += `1. ${ze('紧急止血', 'Emergency Fix')}: ` + fix.emergencyFix.after.replace(/\/\/ /g, '').replace(/\n/g, ' ') + '\n';
            }
            if (fix.rootCauseFix) {
                markdown += `2. ${ze('根因修复', 'Root Cause Fix')}: ${fix.rootCauseFix}\n`;
            }
            if (fix.longTermProtection) {
                markdown += `3. ${ze('长期加固', 'Long-term Protection')}: ${fix.longTermProtection}\n`;
            }
            if (fix.emergencyFix) {
                markdown += '```cpp\n';
                markdown += `// ${ze('修复前', 'Before Fix')}\n`;
                markdown += `${fix.emergencyFix.before}\n\n`;
                markdown += `// ${ze('修复后', 'After Fix')}\n`;
                markdown += `${fix.emergencyFix.after}\n`;
                markdown += '```\n\n';
            }
            markdown += '\n';
        }
        if (conclusion.platformRelevance) {
            markdown += `${ze('机型相关性分析', 'Device Model Relevance Analysis')}:\n${conclusion.platformRelevance}\n\n`;
        }
        if (conclusion.logAnalysis) {
            markdown += `${ze('日志分析', 'Log Analysis')}:\n${conclusion.logAnalysis}\n\n`;
        }
    }
    return markdown;
}
export const AiIssueAnalysisUtil = Object.freeze({
    /** 将markdown或者json统一转换成 */
    convertAnswerToMarkdownText(text) {
        if (!text) {
            return '';
        }
        // 把text开头的```json和结尾的```都去掉
        text = (text || '').replace(/^```json\n/, '')
            .replace(/```$/, '')
            .trimStart();
        // 判断是否以左花括号开头，是的话判断为json，否则为markdown
        const isJson = text.startsWith('{');
        if (!isJson) {
            return text;
        }
        else {
            try {
                return convertJsonTextToMarkdownText(text.trim());
            }
            catch (e) {
                console.error('convertAnswerToMarkdownText error: ', e);
                return text;
            }
        }
    },
    /** 导出 convertJsonTextToMarkdownText 供外部使用 */
    convertJsonTextToMarkdownText(jsonText) {
        return convertJsonTextToMarkdownText(jsonText);
    },
    markdownFence(body) {
        return markdownFence(body);
    },
    appendQuotedLogButton(content, index) {
        return appendQuotedLogButton(content, index);
    },
    enrichQuotedLogLines(lines, matchIndex) {
        return enrichQuotedLogLines(lines, matchIndex);
    },
    splitCodeForSoftWrap(text) {
        return splitCodeForSoftWrap(text);
    },
});
